export const FETCH_EXPERIENCE_LIST = "FETCH_EXPERIENCE_LIST";
export const FETCH_EXPERIENCE_LIST_SUCCESS = "FETCH_EXPERIENCE_LIST_SUCCESS";
export const FETCH_EXPERIENCE_LIST_FAILED = "FETCH_EXPERIENCE_LIST_FAILED";

export const FETCH_EXPERIENCE_DETAILS = "FETCH_EXPERIENCE_DETAILS";
export const FETCH_EXPERIENCE_DETAILS_SUCCESS =
  "FETCH_EXPERIENCE_DETAILS_SUCCESS";
export const FETCH_EXPERIENCE_DETAILS_FAILED =
  "FETCH_EXPERIENCE_DETAILS_FAILED";

export const CREATE_EXPERIENCE = "CREATE_EXPERIENCE";
export const CREATE_EXPERIENCE_SUCCESS = "CREATE_EXPERIENCE_SUCCESS";
export const CREATE_EXPERIENCE_FAILED = "CREATE_EXPERIENCE_FAILED";

export const UPDATE_EXPERIENCE = "UPDATE_EXPERIENCE";
export const UPDATE_EXPERIENCE_SUCCESS = "UPDATE_EXPERIENCE_SUCCESS";
export const UPDATE_EXPERIENCE_FAILED = "UPDATE_EXPERIENCE_FAILED";

export const EXPERIENCE_UPDATE_DETAILS = "EXPERIENCE_UPDATE_DETAILS";
export const EXPERIENCE_UPDATE_DETAILS_SUCCESS = "EXPERIENCE_UPDATE_DETAILS_SUCCESS";
export const EXPERIENCE_UPDATE_DETAILS_FAILED = "EXPERIENCE_UPDATE_DETAILS_FAILED";
